import { render } from "./OffHourPage.vue?vue&type=template&id=bd48548e&ts=true"
import script from "./OffHourPage.vue?vue&type=script&lang=ts"
export * from "./OffHourPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__